import React from "react";

const Portifolio = props => {
  return (
    <div id="portfolio" className="container-fluid text-center bg-grey">
      <h2>Portfolio</h2>
      <br />
      <h4>O que nós criamos para você</h4>
      <br />
      <div
        id="myCarousel"
        className="carousel slide text-center"
        data-ride="carousel"
      >
        {/* Indicators */}
        <ol className="carousel-indicators">
          <li data-target="#myCarousel" data-slide-to="0" className="active" />
          <li data-target="#myCarousel" data-slide-to="1" />
          <li data-target="#myCarousel" data-slide-to="2" />
          <li data-target="#myCarousel" data-slide-to="3" />
          <li data-target="#myCarousel" data-slide-to="4" />
                          
        </ol>

        {/* Wrapper for slides */}
        <div className="carousel-inner" role="listbox">
          <div className="item active">
            <div>
              <img
                src={require("../images/1.png")}
                alt="Paris"
                width="400"
                height="700"
              />
              <br />
              <p>
                <strong>Tela de Login</strong>
              </p>
              <br />
            </div>
            <br />
          </div>
          <div className="item">
            <div>
              <img
                src={require("../images/2.png")}
                alt="Paris"
                width="400"
                height="700"
              />
              <br />
              <p>
                <strong>Tela de Registros de passagens do Vigilante</strong>
              </p>
              <br />
            </div>
            <br />
          </div>
          <div className="item">
            <div>
              <img
                src={require("../images/3.png")}
                alt="Paris"
                width="400"
                height="700"
              />
              <br />
              <p>
                <strong>Tela de Chamados</strong>
              </p>
              <br />
            </div>
            <br />
          </div>
          <div className="item">
            <div>
              <img
                src={require("../images/4.png")}
                alt="Paris"
                width="400"
                height="700"
              />
              <br />
              <p>
                <strong>Tela de Parceiros</strong>
              </p>
              <br />
            </div>
            <br />
          </div>
          <div className="item">
            <div>
              <img
                src={require("../images/5.png")}
                alt="Paris"
                width="400"
                height="700"
              />
              <br />
              <p>
                <strong>Tela de perfil</strong>
              </p>
              <br />
            </div>
            <br />
          </div>        
        </div>

        {/* Left and right controls */}
        <a
          className="left carousel-control"
          href="#myCarousel"
          role="button"
          data-slide="prev"
        >
          <span
            className="glyphicon glyphicon-chevron-left"
            aria-hidden="true"
          />
          <span className="sr-only">Previous</span>
        </a>
        <a
          className="right carousel-control"
          href="#myCarousel"
          role="button"
          data-slide="next"
        >
          <span
            className="glyphicon glyphicon-chevron-right"
            aria-hidden="true"
          />
          <span className="sr-only">Next</span>
        </a>
      </div>
    </div>
  );
};

export default Portifolio;

/** 
 * <div className="row text-center ">
        <div className="col-sm-4">
          <div className="thumbnail">
            <p>
              <strong>Paris</strong>
            </p>
            <p>Yes, we built Paris</p>
          </div>
        </div>
        <div className="col-sm-4">
          <div className="thumbnail">
            <img src="newyork.jpg" alt="New York" width="400" height="300" />
            <p>
              <strong>New York</strong>
            </p>
            <p>We built New York</p>
          </div>
        </div>
        <div className="col-sm-4">
          <div className="thumbnail">
            <img
              src="sanfran.jpg"
              alt="San Francisco"
              width="400"
              height="300"
            />
            <p>
              <strong>San Francisco</strong>
            </p>
            <p>Yes, San Fran is ours</p>
          </div>
        </div>
      </div>
*/
